import React from "react";
import PropTypes from "prop-types";

const Icon = ({ pathFill, ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      {...rest}
    >
      <path
        d="M5.39179 9.48572C6.04082 9.48572 6.65657 9.60221 7.23904 9.83518C7.82149 10.0682 8.354 10.4093 8.83665 10.8587L18.3724 19.9701H18.9715C19.2544 19.9701 19.4916 19.8744 19.6829 19.683C19.8743 19.4916 19.97 19.2544 19.97 18.9716C19.97 18.8384 19.9575 18.697 19.9325 18.5472C19.9076 18.3974 19.8202 18.2477 19.6705 18.0978L15.1023 13.5297L13.33 8.18764L11.4827 8.63698C10.8503 8.8034 10.2761 8.68691 9.76025 8.28751C9.24436 7.8881 8.98638 7.3639 8.98638 6.71488V4.61801L8.28744 4.26853L4.44321 9.41085C4.42657 9.42747 4.41824 9.43994 4.41824 9.44832C4.41824 9.45663 4.40992 9.4691 4.39328 9.48572H5.39179ZM5.39179 11.4827H4.24351C4.29343 11.5992 4.35583 11.7074 4.43072 11.8073C4.50562 11.9071 4.59298 11.9986 4.69283 12.0819L12.7807 19.4459C12.9638 19.6289 13.1718 19.762 13.4048 19.8453C13.6378 19.9284 13.8791 19.9701 14.1288 19.9701H15.4767L7.46371 12.3065C7.18079 12.0236 6.86042 11.8156 6.50263 11.6825C6.14483 11.5493 5.77455 11.4827 5.39179 11.4827ZM14.1288 21.9671C13.6295 21.9671 13.1552 21.8755 12.7059 21.6925C12.2565 21.5094 11.8405 21.2514 11.4577 20.9187L3.34485 13.5547C2.57933 12.8557 2.1508 11.9986 2.05927 10.9835C1.96774 9.96837 2.22985 9.04476 2.8456 8.21264L6.68985 3.07032C6.97276 2.68756 7.35137 2.43377 7.82564 2.30896C8.29991 2.18415 8.7534 2.23823 9.18612 2.47122L9.88506 2.82069C10.2345 3.00375 10.505 3.25338 10.6963 3.56958C10.8878 3.88577 10.9834 4.23525 10.9834 4.61801V6.71488L12.8307 6.24059C13.33 6.10745 13.8125 6.16985 14.2785 6.4278C14.7444 6.68575 15.0607 7.05603 15.2271 7.53863L16.8496 12.4313L21.0933 16.675C21.4262 17.0078 21.655 17.3656 21.7798 17.7484C21.9046 18.1312 21.967 18.5389 21.967 18.9716C21.967 19.8036 21.6758 20.5109 21.0933 21.0934C20.5108 21.6759 19.8036 21.9671 18.9715 21.9671H14.1288Z"
        fill={pathFill}
      />
    </svg>
  );
};

Icon.propTypes = {
  pathFill: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string
};

Icon.defaultProps = {
  pathFill: "#FF8B22",
  width: "24",
  height: "24"
};

export default Icon;
